module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/07_shape-md-343ca964a9d651f814bfe780d5f67e34.png";